// istanbul ignore file
/* eslint-disable react/no-deprecated */
import React from 'react';
import { hydrate } from 'react-dom';

import { App } from './App';
import { getHydrateData } from './utils/getHydrateData';
import { getHydrateTarget } from './utils/getHydrateTarget';

// we need to decide how to handle validation errors
const initialData = getHydrateData();
const container = getHydrateTarget();

hydrate(<App initialData={initialData} />, container);
